import React from 'react'
import { Box, Grid, makeStyles, Typography } from '@material-ui/core'

const imageCommon = {
  display: 'block',
  width: 'auto',
  height: 'auto',
  maxWidth: 75,
  maxHeight: 65,
  objectFit: 'cover',
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'row',
    maxWidth: 600,
  },
  imageTag00: {
    ...imageCommon,
  },
  imageTag01: {
    ...imageCommon,
    maxWidth: 85,
  },
  imageTag02: {
    ...imageCommon,
  },
  imageTag03: {
    ...imageCommon,
  },
  imageTag04: {
    ...imageCommon,
    maxHeight: 55,
  },
  imageTag05: {
    ...imageCommon,
    maxHeight: 40,
  },
  imageTag06: {
    ...imageCommon,
    maxWidth: 65,
  },
  imageTag07: {
    ...imageCommon,
    maxWidth: 85,
  },
  text: {
    color: '#888'
  }
}))

export default function FooterLogos() {
  const classes = useStyles()

  return (
    <Grid container item xs={ 12 }>
      <Grid mt={ 3 } item xs={ 12 } style={{ textAlign: 'center', marginTop: '10px' }}>
        <Typography variant="caption" className={ classes.text }>
          Patrocinadoras do Pacote Comemorativo ISE 15 Anos
        </Typography>
      </Grid>
      <Box my={ 1 } className={ classes.wrapper }>
        <img height="6000" width="3600" className={ classes.imageTag00 } src="/img/01_logo_novo_br_distribuidora.png" alt="logo" />
        <img height="512"  width="512"  className={ classes.imageTag01 } src="/img/02_logo-bradesco.png" alt="logo" />
        <img height="1844" width="3985" className={ classes.imageTag02 } src="/img/03_logo_braskem.png" alt="logo" />
        <img height="1280" width="3500" className={ classes.imageTag03 } src="/img/04_logo_copel.png" alt="logo" />
        <img height="680"  width="680"  className={ classes.imageTag04 } src="/img/05_logo_itau.png" alt="logo" />
        <img height="891"  width="1280" className={ classes.imageTag05 } src="/img/06_logo-klabin.png" alt="logo" />
        <img height="1844" width="3331" className={ classes.imageTag06 } src="/img/07_logo_mrv.png" alt="logo" />
        <img height="832"  width="2326" className={ classes.imageTag07 } src="/img/08_logo_santander.png" alt="logo" />
      </Box>
    </Grid>
  )
}
